import { rankingData } from '@/mocks/homeData';

const badgeColors: Record<string, string> = {
  '独家': 'bg-primary-500 text-white',
  '实锤': 'bg-accent-500 text-white',
  '跟进': 'bg-secondary-500 text-white',
  '热': 'bg-accent-400 text-white',
};

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500 text-white text-xs font-black">{rank}</span>;
  if (rank === 2) return <span className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-500 text-white text-xs font-black">{rank}</span>;
  if (rank === 3) return <span className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-500 text-white text-xs font-black">{rank}</span>;
  return <span className="w-7 h-7 flex items-center justify-center rounded-md bg-background-200 text-foreground-600 text-xs font-bold">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[960px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100 rounded-full mb-3">
            实时热榜
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">热度榜单</h2>
          <p className="mt-2 text-sm text-foreground-600">全网最热爆料实时排名</p>
        </div>

        <div className="space-y-2">
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="flex items-center gap-3 md:gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  {item.badge && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded ${badgeColors[item.badge] || ''}`}>
                      {item.badge}
                    </span>
                  )}
                  <span className="text-xs text-foreground-500">{item.category}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-xs md:text-sm font-bold text-accent-600 whitespace-nowrap">{item.heat}</div>
                <div className="text-[11px] text-foreground-500">{item.time}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}